export default __webpack_public_path__ + "static/1-a5fc8db45201c9ad6ff871f2fe4a6678.jpeg";